<template>
    <v-container fluid class="pa-0">

        <v-row align="center" justify="center">
            <v-col cols="10" sm="6" md="4" lg="4" xl="3">
                <v-card :class="classVCart()">
                    <v-card-subtitle>
                        <p class="ma-0"> {{$t("login.description")}} </p>
                    </v-card-subtitle>

                    <v-card-text>
                        <v-form ref="loginForm" v-on:submit.prevent>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                            v-model="form.password" :append-icon="form.show ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="form.show ? 'text' : 'password'"
                                            label="Password" color="green"
                                            @click:append="form.show = !form.show"
                                            v-on:keyup.enter="submit">

                                    </v-text-field>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="5">
                                    <v-btn color="primary" @click="submit"> {{$t("login.sendButton")}} </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <p class="ma-0 mt-3">
                                    {{$t("login.requestPassword")}}
                                </p>
                            </v-row>
                            <v-row>
                                <v-col cols="5" class="pa-2">
                                    <v-icon>
                                        mdi-whatsapp
                                    </v-icon>
                                    <a :href=getWhatsappMsg()
                                       target= "_blank" class="ma-0">{{$t("login.requestLink")}}</a>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="5" class="pa-2">
                                    <v-icon>
                                        mdi-email
                                    </v-icon>
                                    <a @click="sendPasswordRequestMsg" href="" class="ma-0">{{$t("login.requestLink2")}}</a>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
                <p v-if="showError" id="error">{{$t("login.error")}}</p>

            </v-col>
        </v-row>


    </v-container>

</template>

<script>
    import { mapActions } from "vuex";
    export default {
        name: "Login",
        components: {},
        data() {
            return {
                form: {
                    password: "",
                    show: false
                },
                showError: false,
                whatsappMsg: this.$t("login.whatsappMessage")
            };
        },
        methods: {
            ...mapActions(["LogIn"]),
            async submit() {
                const User = new FormData();
                User.append("password", this.form.password);
                try {
                    await this.LogIn(User);
                    if (this.$route.query.nextUrl != null) {
                      await this.$router.push(this.$route.query.nextUrl)
                    } else {
                      await this.$router.push('/')
                    }
                    //await this.$router.push("/blitzSS21");
                    this.showError = false
                } catch (error) {
                    this.showError = true
                }
            },
            sendPasswordRequestMsg() {

                var subject = this.$t("login.emailSubject");
                var message = this.$t("login.emailMessage");

                window.open('mailto:info@blitzmoda.it?subject=' + subject + '&body=' + message);
            },
            getWhatsappMsg(){
                return this.$t("login.whatsappMessage")
            },
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
            classVCart(){
                if(this.isMobile()){
                    return "px-4 mt-10";
                } else {
                    return "px-4";
                }
            },
            submitIfEnter: function(e) {
                if (e.keyCode === 13) {
                    //alert('Enter was pressed');
                    this.submit()
                }
            },
        },
    };
</script>

<style scoped>
    #error {
        color: red;
    }
</style>